<template>
    <div class="flex h-30 w-full gap-2">
        <div
            class="z-10 flex flex-col justify-between text-end font-bold"
            :class="labels.length > 0 ? 'pb-6' : ''"
        >
            <div>{{ maxVal }}</div>
            <div>{{ (maxVal - minVal) / 2 }}</div>
            <div>{{ minVal }}</div>
        </div>
        <div class="relative flex flex-1 items-end gap-0.5 px-2">
            <div
                v-for="(value, index) in data"
                class="relative flex h-full flex-1 flex-col justify-end"
                :class="labels.length > 0 ? 'pb-6' : ''"
                :key="index"
            >
                <div
                    :class="value > average ? '!bg-green-600' : 'bg-zinc-600'"
                    :style="{ height: ((value - this.minVal) / this.range) * 100 + '%' }"
                ></div>
                <div
                    class="absolute -right-[1px] -left-[1px] h-1/2 translate-y-[1px] bg-gradient-to-t from-zinc-800 to-transparent"
                    :class="labels.length > 0 ? 'bottom-6' : 'bottom-0'"
                ></div>
                <div
                    class="absolute right-0 bottom-0 left-0 z-10 text-center text-xs font-bold text-white uppercase"
                    v-if="labels[index]"
                >
                    {{ labels[index] }}
                </div>
            </div>
            <div
                v-if="showAverage"
                class="absolute -right-0.5 -left-0.5 h-[2px] w-full bg-white"
                :style="{ bottom: ((average - this.minVal) / this.range) * 100 + '%' }"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BarGraph',
    props: {
        data: {
            type: Array,
            required: true,
        },
        autorange: {
            type: Boolean,
            default: false,
        },
        showAverage: {
            type: Boolean,
            default: false,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
        labels: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        maxVal() {
            if (this.autorange && this.data.length > 0) {
                return Math.max(...this.data)
            }
            return this.max
        },
        minVal() {
            if (this.autorange && this.data.length > 0) {
                return Math.min(...this.data)
            }
            return this.min
        },
        average() {
            if (this.data.length === 0) return 0
            return this.data.reduce((a, b) => a + b, 0) / this.data.length
        },
        range() {
            const range = this.maxVal - this.minVal
            return range === 0 ? 1 : range
        },
    },
    methods: {},
}
</script>
